import Vue from 'vue'
import Vuex from 'vuex'
// import { isEdge } from '../lib/ua'

Vue.use(Vuex)

export const PAGE_POSITION_DISTANCE = 50
export const DELAY = 5
export const PAGES = ['concept', 'business', 'company', 'contact']
export const DEVICE_TYPES = { PC: 'pc', SP: 'sp' }

const MOVE_COUNT = PAGE_POSITION_DISTANCE + DELAY
const isMS = false // isEdge

export default new Vuex.Store({
  state: {
    position: 0,
    deviceType: DEVICE_TYPES.PC,
    focusInput: false,
    scrollable: true,
    scrolling: false,
    scrollingTimer: null,
    moveCount: 0,
    scrollTimer: null
  },
  getters: {
    currentPage(state, getters) {
      return PAGES[getters.currentPageIndex]
    },
    currentPageIndex(state) {
      const index = Math.floor(
        state.position / (PAGE_POSITION_DISTANCE + DELAY)
      )

      return index >= PAGES.length ? PAGES.length - 1 : index < 0 ? 0 : index
    },
    conceptPageRate(state) {
      return Math.min(state.position / PAGE_POSITION_DISTANCE, 1)
    },
    businessPageRate(state) {
      const rate =
        (state.position - PAGE_POSITION_DISTANCE - DELAY) /
        PAGE_POSITION_DISTANCE
      return Math.min(rate, 1)
    },
    companyPageRate(state) {
      const rate =
        (state.position - (PAGE_POSITION_DISTANCE + DELAY) * 2) /
        PAGE_POSITION_DISTANCE
      return Math.min(rate, 1)
    },
    contactPageRate(state) {
      const rate =
        (state.position - (PAGE_POSITION_DISTANCE + DELAY) * 3) /
        PAGE_POSITION_DISTANCE
      return Math.min(rate, 1)
    },
    isPC(state) {
      return state.deviceType === DEVICE_TYPES.PC
    },
    isSP(state) {
      return state.deviceType === DEVICE_TYPES.SP
    }
  },

  mutations: {
    setScrolling(state, scrolling) {
      state.scrolling = scrolling
    },

    setScrollable(state, scrollable) {
      state.scrollable = scrollable
    },

    setFocusInput(state, inputting) {
      state.focusInput = inputting
    },

    setDeviceType(state, type) {
      state.deviceType = type
    },

    setPcDeviceType(state) {
      state.deviceType = DEVICE_TYPES.PC
    },

    setSpDeviceType(state) {
      state.deviceType = DEVICE_TYPES.SP
    },

    setPosition(state, position) {
      if (state.scrolling) {
        return
      }

      if (
        state.position + position >=
        (PAGE_POSITION_DISTANCE + DELAY) * PAGES.length
      ) {
        state.position = (PAGE_POSITION_DISTANCE + DELAY) * PAGES.length
        return
      }

      if (state.position + position < 0) {
        state.position = 0
        return
      }

      let spMode = false
      let backMode = position < 0
      let moveAmount = position * (isMS ? 1 : PAGE_POSITION_DISTANCE)

      if (
        state.deviceType === DEVICE_TYPES.SP &&
        state.position < MOVE_COUNT * (PAGES.length - 2)
      ) {
        spMode = true
        moveAmount /= 2
      }
      const splitValue = (state.position + position) % MOVE_COUNT
      let scrollInterval = spMode ? 1000 : backMode ? 1500 : 3000

      if (splitValue >= PAGE_POSITION_DISTANCE) {
        state.position += position

        return
      }

      if (splitValue === 0) {
        state.position += position
      }

      state.scrolling = true

      if (state.position < MOVE_COUNT) {
        scrollInterval = 1500
      }

      state.scrollTimer = setInterval(() => {
        if (state.moveCount >= PAGE_POSITION_DISTANCE) {
          state.moveCount = 0

          if (state.position < MOVE_COUNT) {
            spMode = false
          }

          if (spMode) {
            spMode = false
            return
          }

          clearInterval(state.scrollTimer)
          state.scrolling = false

          if (backMode) {
            state.scrolling = true
            state.position -= 1

            setTimeout(() => {
              state.scrolling = false
            }, 1000)
          }

          return
        }

        if (!isMS && state.moveCount === 0) {
          state.position += moveAmount
        }

        if (isMS) {
          state.position += moveAmount
        }

        state.moveCount++
      }, scrollInterval / PAGE_POSITION_DISTANCE)
    },
    setPage(state, pageName) {
      const index = PAGES.indexOf(pageName)

      state.position = (index + 1) * (PAGE_POSITION_DISTANCE + DELAY) - 1
    }
  },
  actions: {},
  modules: {}
})
